import VariableScopeCell from "./VariableScopeCell";

export default VariableScopeCell;
